export default __webpack_public_path__ + "static/media/ThreeDotLoader.d10bbac4.svg";